import React from 'react';

import styled from '@emotion/styled';

import { FullTextLogo } from '../CompanyLogo';

const LogoHeader = () => {
  return (
    <Container>
      <FullTextLogo />
    </Container>
  );
};

export default LogoHeader;

const Container = styled.div`
  height: 6.3125rem;
  background-color: ${({ theme }) => theme.palette.blankHeaderBackground};
  display: flex;
  align-items: center;

  & > * {
    margin-left: 3.56rem;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;
